import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { getAllComments } from "../../store/comments";
import Comments from "../Comments";
import PageNotFound from "../PageNotFound";
import { GoCommentDiscussion } from "react-icons/go";

import "./onePost.css";
import Votes from "../Votes";
import CommentForm from "../CommentForm";

import serveImageError from "../Errors/imageNotFound";


const OnePost = () => {
  const dispatch = useDispatch();
  const { postId } = useParams();
  const postIdNum = Number(postId);
  const user = useSelector((state) => state?.session?.user);
  const getPosts = useSelector((state) => state.post.list);
  const getComments = useSelector((state) => state.comments);

  const post = useMemo(() => {
    const singlePost = getPosts.filter((post) => post.id === postIdNum);
    if (singlePost.length) {
      return singlePost[0];
    } else {
      // TODO: handle this better - should not fail but if it does what do?
      return []
    }
  }, [getPosts, postIdNum]);

  const comments = useMemo(() => {
    return Object.values(getComments).filter(
      (comment) => comment.parentId === null && comment.postId === postIdNum
    )
  }, [getComments, postIdNum]);

  const postComments = useMemo(() => {
    return Object.values(getComments).filter(
      (comment) => comment.postId === postIdNum
    )
  }, [getComments, postIdNum]);

  const [showBtns, setShowBts] = useState(true);
  // const [errors, setErrors] = useState([]);
  // const [errorsEdit, setErrorsEdit] = useState([]);

  // useEffect(() => {
  //     const err = [];
  //     if (newComment.length > 250 || newComment.length < 5) {
  //         err.push("Your comment cannot be longer than 250 characters or shorter than 5 characters.");
  //     };

  //     setErrors(err);
  // }, [newComment]);

  // useEffect(() => {
  //     const err = [];
  //     if (commentToEdit.length > 250 || commentToEdit.length < 5) {
  //         err.push("Your comment cannot be longer than 250 characters or shorter than 5 characters.");
  //     };
  //     setErrorsEdit(err);
  // }, [commentToEdit]);

  useEffect(() => {
    //TODO: Fix name to getAllCommentsOnPost
    dispatch(getAllComments(postId));
  }, [dispatch, postId]);


  const backToTop = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
  };

  setTimeout(() => {
    if (!post) {
      return <PageNotFound />;
    }
  }, 2000);

  return (
    <div className="pagee">
      <div className="outer-page">
        <div className="main-feed-containers">
          <div className="posts">
            <div className="idk">
              <div className="left-postt">
                <Votes post={post} />
              </div>
              <div className="one-post-main-content">
                <div className="one-post-username">
                  <p>Posted by u/{post?.username}</p>
                </div>
                <div className="post-title">{post?.title}</div>
                <div className="post-body">
                  <p className="post-body-text">{post?.body}</p>
                </div>
                <div className="one-post-image">
                  <img
                    className="img-tag"
                    src={`${post?.image}`}
                    alt=""
                    onError={(e) => {
                      e.currentTarget.src = serveImageError();
                      e.target.onError = null;
                    }}
                  />
                </div>
                <div className="one-post-comment-count">
                  <div className="comment-count">
                    <GoCommentDiscussion id="comment-count-icon" />
                    <span id="count">{postComments.length}</span> Comments
                    <div className="mobile-count">
                      <Votes postId={postId} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="newCommentEditForm">
              {user ? (
                <CommentForm
                  postId={postId}
                  showBtns={showBtns}
                  setShowBts={setShowBts}
                />
              ) : (
                <>
                  <p className="not-signed-in-comment">
                    Wanna Leave a comment?{" "}
                    <NavLink to={"/signup"} className="sign-in-or-up">
                      {" "}
                      Sign Up{" "}
                    </NavLink>{" "}
                    or{" "}
                    <NavLink to={"/login"} className="sign-in-or-up">
                      Login
                    </NavLink>{" "}
                  </p>
                </>
              )}
              <div className="comments">
                {comments
                  ?.map((comment) => (
                    <div key={comment.id}>
                      <Comments comment={comment} postId={postId} />
                    </div>
                  ))
                  ?.reverse()}
              </div>
            </div>
          </div>
          <button className="backToTop" onClick={backToTop}>
            Back to Top
          </button>
        </div>
        <div className="right-container">
          <div className="communities">
            <div className="comm">
              <div className="comm-header">
                <p>Top Communities</p>
              </div>
              <div className="rows">
                <i
                  style={{ color: "#04eb04" }}
                  className="fa-solid fa-angle-up"
                ></i>
                p/Crabs
              </div>
              <div className="rows">
                <i
                  style={{ color: "#04eb04" }}
                  className="fa-solid fa-angle-up"
                ></i>
                p/Armidillos
              </div>
              <div className="rows">
                <i
                  style={{ color: "red" }}
                  className="fa-solid fa-angle-down"
                ></i>
                p/Sugar_gliders
              </div>
              <div className="rows">
                <i
                  style={{ color: "#04eb04" }}
                  className="fa-solid fa-angle-up"
                ></i>
                p/Dogs
              </div>
              <div className="rows">
                <i
                  style={{ color: "#04eb04" }}
                  className="fa-solid fa-angle-up"
                ></i>
                p/Cats
              </div>
              <div className="rows">
                <i
                  style={{ color: "#04eb04" }}
                  className="fa-solid fa-angle-up"
                ></i>
                p/Giraffe
              </div>
              <div className="rows">
                <i
                  style={{ color: "#04eb04" }}
                  className="fa-solid fa-angle-up"
                ></i>
                p/Squirrel
              </div>
              <button id="view-all">View All</button>
            </div>
          </div>

          <div className="createe">
            <div className="links">
              <h5>Personal Links</h5>
              <a href="https://github.com/k-dodsonknapp">GitHub</a>
              <a href="https://www.linkedin.com/in/kenneth-dodson-knapp-97029022a/">
                LinkedIn
              </a>
              <a href="https://angel.co/u/kenneth-dodson-knapp">AngelList</a>
            </div>
            <div className="links">
              <h5>Previous Projects</h5>
              <a href="https://notes-takker.herokuapp.com/">NoteTakker</a>
              <a href="https://step-by-stepapp.herokuapp.com/">Step-by-Step</a>
              <a href="https://carra.herokuapp.com/">Carra</a>
            </div>
          </div>
          <div className="me">
            <p>Developed by: Kenneth Dodson-Knapp</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnePost;
